import { Observable } from 'rxjs';

import { Injectable } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';

import { NzModalService } from 'ng-zorro-antd/modal';

@Injectable()
export class UnsavedModalAlertService {
  constructor(
    private modalService: NzModalService,
    private translate: TranslateService,
  ) {}

  getUnsavedFormModal(skipModal = false) {
    return new Observable((observer) => {
      if (skipModal) {
        observer.next(true);
        observer.complete();
        return;
      }
      this.modalService.create({
        nzTitle: this.translate.instant('common.alert') + '!',
        nzContent: this.translate.instant('common.unsaved-form'),
        nzOnOk: () => {
          observer.next(true);
          observer.complete();
        },
        nzOnCancel: () => {
          observer.next(false);
          observer.complete();
        },
      });
    });
  }
}
